import styled from 'styled-components';

interface IPropsSpin {
  small?: boolean;
}
export const SpinLoadingWrapper = styled.div<IPropsSpin>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  img {
    width: ${(props) => (props?.small ? '25px' : '40px')};
    height: ${(props) => (props?.small ? '25px' : '40px')};
    -webkit-animation: spin 1.5s linear infinite; /* Safari */
    animation: spin 1.5s linear infinite;
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
